import React, { useRef, useState } from 'react';
import './contact.css';
import emailjs from '@emailjs/browser';
import twitterIcon from '../../assets/twitter.png';
import youtubeIcon from '../../assets/youtube.png';
import instagramIcon from '../../assets/instagram.png';

const Contact = () => {
    const form = useRef();
    const successDialog = useRef();
    const sending = useRef(false);
    const [isSending, setIsSending] = useState(false);
    const [error, setError] = useState('');

    const sendEmail = async (e) => {
        e.preventDefault();
        if (sending.current) return;
        sending.current = true;
        setIsSending(true);
        setError('');
        try {
            await emailjs.sendForm('techlensug_smtp', 'template_m1o0v9a', form.current, '2hQHJIQWj301aLPGe');
            form.current.reset();
            successDialog.current.showModal();
        } catch {
            setError('Your message could not be sent. Please try again.');
        } finally {
            sending.current = false;
            setIsSending(false);
        }
    };

    return (
    <div id="contactPage">
        <section id="resources">
            <h2 className="contactPageTitle">Explore my work</h2>
            <p className="clientDesc">Learn about the programme and the conversations surrounding mentorship for young men.</p>
            <div className="resourceLinks">
                <a href="https://boysmentorship.africa/our-story/" target="_blank" rel="noopener noreferrer">Our story &amp; mission</a>
                <a href="https://www.monitor.co.ug/uganda/magazines/life/who-cares-to-mentor-the-younger-men-today--1768126" target="_blank" rel="noopener noreferrer">Mentorship in focus — Daily Monitor</a>
                <a href="https://www.linkedin.com/in/godfrey-kuteesa-3a89651a9/" target="_blank" rel="noopener noreferrer">Find me on LinkedIn</a>
            </div>
        </section>
        <section id="contact">
            <h2 className="contactPageTitle">Contact Me</h2>
            <p className="contactDesc">Please fill out the form below for mentorship and programme enquiries.</p>
            <form className="contactForm" ref={form} onSubmit={sendEmail} aria-busy={isSending}>
                <input type="text" className="name" placeholder="Your name" aria-label="Your name" name="from_name" required readOnly={isSending} />
                <input type="email" className="email" placeholder="Your Email" aria-label="Your email" name="from_email" required readOnly={isSending} />
                <textarea name="message" placeholder="Your Message" aria-label="Your message" rows={5} className="msg" required readOnly={isSending} />
                <button type="submit" value="Send" className="submitBtn" disabled={isSending}>
                    {isSending && <span className="sendingSpinner" aria-hidden="true" />}
                    {isSending ? 'Sending...' : 'Submit'}
                </button>
                <p role="status" className="contactStatus">{isSending ? 'Sending your message. Please wait.' : ''}</p>
                {error && <p role="alert" className="contactError">{error}</p>}
            </form>
            <dialog ref={successDialog} className="contactSuccess" aria-labelledby="contact-success-title" aria-describedby="contact-success-description">
                <span className="successMark" aria-hidden="true">✓</span>
                <h2 id="contact-success-title">Message sent!</h2>
                <p id="contact-success-description">Thank you for reaching out. Your message has been sent successfully.</p>
                <form method="dialog"><button className="submitBtn" autoFocus>Done</button></form>
            </dialog>
            <nav className="links" aria-label="Social profiles and programme website">
                <a href="https://x.com/GODFREY_Kutesa" target="_blank" rel="noopener noreferrer" aria-label="Twitter / X"><img src={twitterIcon} alt="" className="link" /><span>Twitter / X</span></a>
                <a href="https://www.linkedin.com/in/godfrey-kuteesa-3a89651a9/" target="_blank" rel="noopener noreferrer"><span className="socialTextIcon" aria-hidden="true">in</span><span>LinkedIn</span></a>
                <a href="https://www.youtube.com/@Godfrey_KUTEESA" target="_blank" rel="noopener noreferrer"><img src={youtubeIcon} alt="" className="link" /><span>YouTube</span></a>
                <a href="https://www.instagram.com/godfrey.kutesa/?hl=en" target="_blank" rel="noopener noreferrer"><img src={instagramIcon} alt="" className="link" /><span>Instagram</span></a>
                <a href="https://boysmentorship.africa" target="_blank" rel="noopener noreferrer"><span className="socialTextIcon" aria-hidden="true">www</span><span>Website</span></a>
            </nav>
        </section>
    </div>
);

};

export default Contact;

